import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=59ec3733&scoped=true"
import script from "./agreement.vue?vue&type=script&lang=js"
export * from "./agreement.vue?vue&type=script&lang=js"
import style0 from "./agreement.vue?vue&type=style&index=0&id=59ec3733&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ec3733",
  null
  
)

export default component.exports